import ProductImage from '../ProductImage/ProductImage';

const MESES = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
const mesNum = (m) => (typeof m === 'number' ? m : MESES.indexOf(m) + 1);
const mesNome = (m) => (typeof m === 'number' ? MESES[m - 1] : m);
const brl = (v) => (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

// Data "YYYY-MM-DD..." → "seg., 08/06" sem shift de fuso
const fmtDia = (s) => {
  if (!s) return '';
  const m = String(s).match(/^(\d{4})-(\d{2})-(\d{2})/);
  const d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(s);
  return isNaN(d.getTime()) ? String(s) : d.toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit', month: '2-digit' });
};

/**
 * Card flutuante de hover dos Alertas de Vendas. Igual em espírito ao ProductHoverCard,
 * mas no lugar do histórico de compras/reposições mostra o DETALHAMENTO DO MÊS ATUAL
 * (vendas por dia) — o que importa pra confirmar a queda.
 *
 * @param item    alerta { nome, codigo, baselineDiario, atualDiario, quedaPct, estoqueInfo }
 * @param detalhe produto vindo de fetchProdutoDetalhe (historicoVendas, mediaMensal, imagem)
 * @param loading buscando o detalhe
 */
export default function AlertaHoverCard({ item, detalhe, loading, style, pinned = false, onClose }) {
  if (!item) return null;

  const hv = (detalhe?.historicoVendas || []).slice();
  // mês mais recente do histórico = "mês atual"
  let mesAtual = null;
  if (hv.length) {
    mesAtual = hv.reduce((acc, h) => {
      const key = (h.ano || 0) * 100 + mesNum(h.mes);
      return !acc || key > acc._key ? { ...h, _key: key } : acc;
    }, null);
  }
  const diasMesAtual = (mesAtual?.pedidos || [])
    .slice()
    .sort((a, b) => String(b.data).localeCompare(String(a.data)));

  // histórico mensal (mais recente primeiro), limitado
  const mensal = hv
    .map(h => ({ ...h, _k: (h.ano || 0) * 100 + mesNum(h.mes) }))
    .sort((a, b) => b._k - a._k)
    .slice(0, 6);

  const img = detalhe?.imagemURL || detalhe?.imagemBase64 || detalhe?.imagem || item.imagemURL;

  const wrap = pinned ? {
    position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    width: 'min(380px, 94vw)', maxHeight: '88vh', background: '#fff', borderRadius: 14,
    boxShadow: '0 24px 64px rgba(15,23,42,0.45)', border: '1px solid #e5e7eb',
    overflow: 'hidden', display: 'flex', flexDirection: 'column', zIndex: 1000002,
  } : {
    position: 'fixed', width: 320, background: '#fff', borderRadius: 12,
    boxShadow: '0 20px 50px rgba(15,23,42,0.35)', border: '1px solid #e5e7eb',
    overflow: 'hidden', display: 'flex', flexDirection: 'column', ...style,
  };
  const sec = { fontSize: 10, fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', padding: '8px 12px 4px' };
  const rowD = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 12px', fontSize: 11.5 };

  const card = (
    <div style={wrap}>
      <div style={{ position: 'relative', width: '100%', height: 132, background: '#f1f5f9', flexShrink: 0 }}>
        <ProductImage src={img} alt={item.nome} />
        {pinned && (
          <button
            onClick={onClose}
            title="Fechar"
            style={{ position: 'absolute', top: 8, right: 8, width: 30, height: 30, borderRadius: '50%', border: 'none', background: 'rgba(15,23,42,0.6)', color: '#fff', fontSize: 15, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >✕</button>
        )}
      </div>
      <div style={{ padding: '8px 12px 4px', fontWeight: 700, fontSize: 13, color: '#0f172a', lineHeight: 1.25, flexShrink: 0 }}>
        {item.nome}
        <div style={{ fontSize: 11, color: '#94a3b8', fontWeight: 500 }}>#{item.codigo}</div>
      </div>

      {/* Faixa do alerta */}
      <div style={{ display: 'flex', gap: 6, padding: '4px 12px 8px', flexWrap: 'wrap', flexShrink: 0 }}>
        <span style={{ fontWeight: 800, color: '#b91c1c', background: '#fee2e2', padding: '2px 8px', borderRadius: 999, fontSize: 11 }}>▼ {item.quedaPct}%</span>
        <span style={{ color: '#475569', background: '#f1f5f9', padding: '2px 8px', borderRadius: 999, fontSize: 11 }}>{item.baselineDiario}/d → {item.atualDiario}/d</span>
        <span style={{ color: '#334155', background: '#f1f5f9', padding: '2px 8px', borderRadius: 999, fontSize: 11 }}>{item.estoqueInfo}</span>
      </div>

      <div style={{ overflowY: 'auto', borderTop: '1px solid #f1f5f9', ...(pinned ? { flex: 1 } : { maxHeight: '60vh' }) }}>
        {/* Detalhamento do mês atual */}
        <div style={sec}>📋 Detalhamento {mesAtual ? `· ${mesNome(mesAtual.mes)}/${mesAtual.ano}` : 'do mês'}</div>
        {loading ? (
          <div style={{ padding: '8px 12px', fontSize: 12, color: '#94a3b8' }}>Carregando…</div>
        ) : diasMesAtual.length ? (
          diasMesAtual.map((d, i) => (
            <div key={i} style={{ ...rowD, background: i % 2 ? '#fafafa' : '#fff' }}>
              <span style={{ color: '#475569' }}>{fmtDia(d.data)}</span>
              <span style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <span style={{ fontWeight: 700, color: '#0f172a' }}>{d.quantidade} un</span>
                {d.valorTotal != null && <span style={{ color: '#16a34a', minWidth: 64, textAlign: 'right' }}>{brl(d.valorTotal)}</span>}
              </span>
            </div>
          ))
        ) : (
          <div style={{ padding: '8px 12px', fontSize: 12, color: '#dc2626' }}>Sem vendas registradas neste mês.</div>
        )}

        {/* Histórico mensal */}
        {mensal.length > 0 && (
          <>
            <div style={{ ...sec, borderTop: '1px solid #f1f5f9', marginTop: 4 }}>Histórico de Vendas</div>
            {mensal.map((h, i) => (
              <div key={i} style={{ ...rowD, background: i % 2 ? '#fafafa' : '#fff' }}>
                <span style={{ color: '#475569' }}>{mesNome(h.mes)}/{h.ano}</span>
                <span style={{ fontWeight: 700, color: '#0f172a' }}>{h.quantidade || 0}</span>
              </div>
            ))}
            <div style={{ ...rowD, borderTop: '1px solid #e2e8f0', fontWeight: 700 }}>
              <span style={{ color: '#475569' }}>Média Mensal</span>
              <span style={{ color: '#0f172a' }}>{Math.round(detalhe?.mediaMensal || 0)}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );

  if (!pinned) return card;

  // Travado: fundo escuro + card centralizado e rolável
  return (
    <>
      <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.5)', zIndex: 1000001 }} onClick={onClose} />
      {card}
    </>
  );
}
